import { CardColorScheme } from 'features/redemptions/components/CardStatus';
import { RedemptionReport } from 'features/redemptions/ts/RedemptionReport';

export const STATUS_DICTIONARY: Record<RedemptionReport['card_status'], CardColorScheme> = {
  ACTIVE: 'active',
  REDEEMED: 'redeemed',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
};
